import {useMemo} from 'react'
import {SortKeys, SortTypes} from '../functions/Sort'

function useSortedData<T extends Record<string, any>>(
    {data, sortKey, reverse}: SortTypes<T>,
): T[] {

    return useMemo(() => {

        // const dateKeys = new Set(['date', 'called_at', 'created_at', 'archived_at', 'dateHour'])
        const orderMultiplier = reverse ? -1 : 1 // Multiplier to handle reverse logic

        return [...data]
            .sort((a, b) => {

                let aValue = a[sortKey] ?? ''
                let bValue = b[sortKey] ?? ''

                console.log(typeof aValue)

                if (typeof aValue === 'string' && aValue !== '' && !isNaN(Number(aValue))) {
                    aValue = Number(aValue) as NonNullable<T[SortKeys<T>]>
                }
                if (typeof bValue === 'string' && bValue !== '' && !isNaN(Number(bValue))) {
                    bValue = Number(bValue) as NonNullable<T[SortKeys<T>]>
                }


                // Check if the value is a date string in the format 2025-01-12T11:42:07.000000Z
                const isDateString = (value: any): boolean => {
                    if (typeof value !== 'string') return false
                    const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{6}Z$/
                    return dateRegex.test(value)
                }

                // Handle sorting by date fields
                if (isDateString(aValue) || isDateString(bValue)) {
                    const dateA = isDateString(aValue) ? new Date(aValue).getTime() : 0
                    const dateB = isDateString(bValue) ? new Date(bValue).getTime() : 0
                    return (dateA - dateB) * orderMultiplier
                }

                // Handle number comparison
                if (typeof aValue === 'number' && typeof bValue === 'number') {
                    return (aValue - bValue) * orderMultiplier
                }

                // Handle string comparison
                if (typeof aValue === 'string' && typeof bValue === 'string') {
                    return (aValue as string).localeCompare(bValue as string) * orderMultiplier
                }

                // Fallback for non-string, non-number types
                return 0
            })
    }, [data, sortKey, reverse])
}

export {useSortedData}